import React from "react";
import { Typography, Avatar, Box, Paper } from "@mui/material";
import { Person } from "@mui/icons-material";
import { IBuyer } from "../../../../common/utils/interfaces";

type Props = {
  buyerData: IBuyer | null;
};

const BuyerDetails: React.FC<Props> = ({ buyerData }) => {
  if (!buyerData) return null;

  return (
    <Box p={3}>
      <Typography variant="h5" fontWeight={600} mb={3}>
        Buyer Details
      </Typography>

      <Paper elevation={2} sx={{ p: 3, borderRadius: 2 }}>
        <Box display="flex" alignItems="center" mb={2}>
          {buyerData.picture ? (
            <Avatar
              src={buyerData.picture}
              alt={buyerData.first_name}
              sx={{ width: 60, height: 60, mr: 2 }}
            />
          ) : (
            <Person sx={{ fontSize: 60, mr: 2, color: "gray" }} />
          )}
          <Box>
            <Typography variant="h6">
              {buyerData.first_name} {buyerData.last_name}
            </Typography>
            <Typography variant="body2" color="text.secondary">
              Joined:{" "}
              {new Date(buyerData.date_joined).toLocaleDateString(undefined, {
                year: "numeric",
                month: "short",
                day: "numeric",
              })}
            </Typography>
          </Box>
        </Box>

        <Box mt={3}>
          <Typography variant="subtitle2" color="text.secondary">
            Email Address
          </Typography>
          <Typography variant="body1" mb={2}>
            {buyerData.email}
          </Typography>

          <Typography variant="subtitle2" color="text.secondary">
            Phone Number
          </Typography>
          <Typography variant="body1">{buyerData.phone_number}</Typography>
        </Box>
      </Paper>
    </Box>
  );
};

export default BuyerDetails;
